import {
  checkAuthSession,
  removeAuthSession,
  setAuthSession,
} from "theme/utils";
import { getStoreRemoteId } from "utils";
import { request } from "../axios/request";

import {
  FETCH_NAV_HEADER_PENDING,
  FETCH_NAV_HEADER_REJECTED,
  FETCH_NAV_HEADER_FULFILLED,
} from "../constants/navHeader";

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

const pending = () => ({
  type: FETCH_NAV_HEADER_PENDING,
});

const rejected = (error) => ({
  type: FETCH_NAV_HEADER_REJECTED,
  error: error,
});

const fulfilled = (response) => ({
  type: FETCH_NAV_HEADER_FULFILLED,
  response: response,
});

export const fetchCurrentStaff = () => (dispatch) => {
  const storeRemoteId = getStoreRemoteId();
  dispatch(pending());

  request({
    url: $U.CURRENT_STAFF,
    method: "get",
    params: { current_store_remote_id: storeRemoteId },
  })
    .then((response) => {
      const IS_CHECK_AUTH_BRAND = $A.BRAND === "Koton" || $A.BRAND === "TFS";
      if (IS_CHECK_AUTH_BRAND) {
        const isAuthenticated = checkAuthSession();
        if (isAuthenticated) {
          setAuthSession();
          dispatch(fulfilled(response.data));
        }
      } else {
        dispatch(fulfilled(response.data));
      }
    })
    .catch((error) => {
      removeAuthSession();
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/navHeader.js